// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCTmnWg67jTiUd4XSNnGRohJqZfam4B9gI",
  authDomain: "on-farm.firebaseapp.com",
  projectId: "on-farm",
  storageBucket: "on-farm.appspot.com",
  messagingSenderId: "25029215954",
  appId: "1:25029215954:web:29f6d8a9bd0d075eb58f0b",
  measurementId: "G-XXKNPJ3LTN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export {
    auth,
    analytics
};